<template>
  <div>
    <div id="comment-list">
      <div class="review-item" v-for="(message, index) in changeMessageDetail" :key="message.id">
        <div class="user-avatar">
          <img src="../../icons/image/avatar/pic_customer_service_avatar.png" v-if="message.isQuiz">
          <img :src="imageAddress + message.imageName" v-else>
        </div>
        <div class="review-detail">
          <div class="user-detail">
            <div class="user-name" v-if="message.isQuiz">小管子</div>
            <div class="user-name" v-else>{{ message.createName }}</div>
            <div class="user-time">
              <div class="withdraw" @click="handler_withdraw(message.id)" v-if="index === 0 && message.isCancel === 0 && getUserId === message.createId">
                <svg width="16" height="14" viewBox="0 0 16 14" class="hover-active comment-handle">
                  <g stroke-width="1.1" stroke="#999" fill="none" fill-rule="evenodd" stroke-linecap="round">
                    <path stroke-linejoin="round" d="M4.2 7.7L.6 4 4 .7"/><path d="M.8 4.2h9.5c2.6 0 4.7 2 4.7 4.2 0 2.3-2 4.2-4.7 4.2H4"/>
                  </g>
                </svg>
              </div>
              <div>{{ message.createTime | getCreatedTime }}</div>
            </div>
          </div>
          <div class="review-content">
            <div v-if="message.msg">
              <pre :class="[message.isCancel ? 'withdraw-review-content' : '']">{{ message.msg }}</pre>
            </div>
            <div v-if="message.isAttach === 1 && message.fileCode !== undefined" class="img-list">
              <div class="img-item image-view"
                   v-for="(file, fileIndex) of message.mediaList"
                   :key="fileIndex"
                   @click="handlerPreviewFile(file)">
                <video v-if="file.videoSrc" :src="file.videoSrc" muted preload="metadata"></video>
                <img v-else-if="file.src" :src="file.src">
                <div v-else class="video-placeholder"></div>
                <i v-if="file.sourceUrl" class="icon-player-pause"></i>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="load-more" v-show="isLoadingMore">加载中 ...</div>
    </div>
  </div>

</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
import {formatFileMixin} from '../../mixins/format-file'
import Viewer from 'v-viewer/src/component'
export default {
  name: 'commentList',
  mixins: [formatFileMixin],
  props: {
    isLoadingMore: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      imageAddress: 'https://www.erplus.co/image',
      messageDetail: [],
      getMessageTime: null
    }
  },
  components: {
    Viewer
  },
  computed: {
    ...mapGetters([
      'getMessageDetail',
      'getUserId'
    ]),
    getPlayStyle () {
      return {'width': '800px', 'height': '400px', 'position': 'absolute', 'top': '0', 'left': '14%'}
    },
    changeMessageDetail () {
      if (this.getMessageDetail && this.getMessageDetail.length !== 0) {
        return this.getMessageDetail.map(item => {
          const mediaList = item.isAttach !== 0 && item.fileCode !== undefined ? this.formatMediaListFromCodes(item.fileCode) : []
          return Object.assign({}, item, {mediaList})
        })
      } else {
        return []
      }
    },
    previewImgList () {
      let imgList = []
      if (this.changeMessageDetail && this.changeMessageDetail.length !== 0) {
        this.changeMessageDetail.forEach(item => {
          if (item.mediaList && item.mediaList.length !== 0) {
            let list = item.mediaList.filter(item => !item.sourceUrl).map(item => item.src)
            imgList.push(...list)
          }
        })
      }
      return imgList
    }
  },
  methods: {
    ...mapMutations([
      'setImgForPreview',
      'SET_VIDEO_DIALOG'
    ]),
    ...mapActions([
      'action_getQuestionMessagePage'
    ]),
    loadMoreMessage () {
      clearTimeout(this.getMessageTime)
      this.getMessageTime = setTimeout(() => {
        this.$emit('loadMoreMessage')
      }, 3000)
    },
    handler_withdraw (id) {
      this.$emit('handler_withdraw', id)
    },
    handlerPreviewImg (src) {
      this.setImgForPreview({
        imgSrcNeedToPreview: this.previewImgList,
        currImgNeedToPreview: src,
        needShowImgPreviewCommon: true
      })
    },
    handlerPreviewFile (file) {
      if (file.sourceUrl) {
        this.handlerOpenPlayer(file.sourceUrl)
      } else {
        this.handlerPreviewImg(file.src)
      }
    },
    handlerOpenPlayer (src) {
      this.SET_VIDEO_DIALOG(this.buildVideoPlayerParams(src))
    }
  },
  filters: {
    getCreatedTime (value) {
      if (value !== undefined) {
        let day = '周' + '日一二三四五六'.charAt(new Date(value.slice(0, 10).replace(/-/g, '/')).getDay())
        return value.slice(2, 10).replace(/-/g, '/') + ' ' + day + value.slice(10)
      }
    },
    setAnonymous (value) {
      if (value && value !== '小管子') {
        let firstName = value.slice(0, 1)
        let name = '**'
        return firstName + name
      }
    }
  }
}
</script>
<style scoped>
  .icon-player-pause {
    width: 15px;
    height: 15px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
    background: url("~@/icons/icon-player-pause.png") no-repeat;
    background-size: 15px 15px;
    background-position: center;
  }

  img,
  video {
    height: 50px;
    width: 50px;
    object-fit: cover;
    background: #000;
    flex-shrink: 0;
    flex-grow: 0;
    padding: 0;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    position: relative;
  }
  pre {
    padding: 0;
    margin: 0;
    width: 100%;
    font-size: 13px;
    color: #333333;
    line-height: 18px;
    font-family: 'Hiragino Sans GB', 'microsoft yahei', arial, sans-serif;
    letter-spacing: 0;
    white-space: pre-wrap; /*css-3*/
    white-space: -moz-pre-wrap; /*Mozilla,since1999*/
    white-space: -pre-wrap; /*Opera4-6*/
    white-space: -o-pre-wrap; /*Opera7*/
    word-break: break-all;
  }

  #comment-list {
    /*width: 481px;*/
    width: 100%;
    margin-top: 12px;
  }
  .load-more {
    width: 100%;
    height: 20px;
    text-align: center;
    font-size: 14px;
    color: #333;
  }

  .review-item {
    display: flex;
    padding-top: 10px;
    padding-left: 15px;
    margin-bottom: 1px;
    background: #fff;
  }

  .essence {
    background: #fff url("../../icons/essence-mark.svg") no-repeat right top;
  }

  .no-essence {
    background: #fff url("../../icons/essence-mark.-gray.svg") no-repeat right top;
  }

  .user-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin-right: 8px;
  }
  .user-avatar img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin: 0;
  }

  .review-detail {
    width: calc(100% - 42px);
    box-sizing: border-box;
    padding-bottom: 14px;
  }

  .review-item:nth-last-child(1) .review-detail {
    padding-bottom: 5px;
  }

  .user-detail {
    display: flex;
    justify-content: space-between;
    height: 21px;
    margin-bottom: 4px;
    line-height: 21px;
  }

  .user-name {
    font-size: 15px;
    color: #333333;
    letter-spacing: -0.36px;
  }

  .user-time {
    display: flex;
    justify-content: space-between;
    height: 21px;
    margin-right: 20px;
    font-size: 15px;
    color: #999999;
    line-height: 21px;
  }

  .withdraw {
    margin-right: 8px;
  }

  svg.hover-active:hover g{
    stroke: #4A90E2;
  }
  .comment-handle{
    cursor: pointer;
  }

  .review-content {
    /*width: 392px;*/
    margin-right: 12px;
    font-size: 13px;
    color: #333333;
    line-height: 18px;
    letter-spacing: -0.31px;
    overflow: hidden;
    word-wrap: break-word;
  }
  .withdraw-review-content {
    color: #999;
  }
  .img-list {
    display: flex;
    flex-wrap: wrap;
  }
  .img-item {
    display: flex;
    flex: 0 0 50px;
    flex-wrap: wrap;
    position: relative;
    margin-right: 5px;
    margin-top: 5px;
    cursor: pointer;
  }
  .video-placeholder {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    background: #000;
  }

</style>



// WEBPACK FOOTER //
// src/components/comment-list/comment-list.vue